import {
  Component,
  Input,
  forwardRef,
  EventEmitter,
  Output
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'mapfre-custom-toggle',
  templateUrl: './custom-toggle.component.html',
  styleUrls: ['./custom-toggle.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomToggleComponent),
      multi: true
    }
  ]
})
export class CustomToggleComponent {
  @Input() checked = false;
  @Input() toggleId = 'toggle00';
  @Output() value = new EventEmitter();

  writeValue(value: any) {
    this.checked = value;
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn) {}

  propagateChange(event) {}

  onChange() {
    this.propagateChange(this.checked);
    this.value.emit(this.checked);
  }
}
